//@ts-check
import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "../../../core/Button";
import withUserInfo from "../../../core/EcrionProvider/boot/withUserInfo";
import useProvider from "../../../core/EcrionProvider/useProvider";
import FragmentContainer from "./FragmentContainer";

var ResetSettingsFragment = function ResetSettingsFragment(_ref) {
  var userInfo = _ref.userInfo;

  var _useProvider = useProvider(),
      routes = _useProvider.routes;

  var history = routes && routes.history;
  var hasManagePermission = userInfo && userInfo.permissions.indexOf("ManageEnvironment") > -1;
  return React.createElement(FragmentContainer, {
    title: "Reset"
  }, React.createElement(Typography, null, "Use the option below to return this application to its original state including settings and configurations."), React.createElement(Typography, {
    gutterBottom: true
  }, React.createElement("b", null, "WARNING:"), " If you press Reset to Default, all content associated with this application including any changes made by you or other users will be removed."), React.createElement(Button, {
    disabled: !hasManagePermission,
    color: "danger",
    onClick: function onClick() {
      return history.push("/installation/reset");
    }
  }, "Reset to Default"));
};

ResetSettingsFragment.defaultProps = {};
export default withUserInfo(ResetSettingsFragment);